// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#family-edit[data-v-e1355b78]{max-width:600px;margin-left:auto;margin-right:auto}#family-edit .cancel-btn[data-v-e1355b78],#family-edit .register-btn[data-v-e1355b78]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
